import React, { useState, useEffect } from "react";
import moment from "moment";
import UseWindowSize from "../UseWindowSize";
import HeadingComponent from "../UserInterface/HeadingComponent";
import { Slider } from "../Slider";
import { CardContainer } from "../UserInterface/CardContainer";
import fetch from "../../utils/fetch";
import { checkIsFromDashboard, inIframe } from "../../utils/helpers";
import Router from "next/router";

const Reward = ({ rewardBanners }) => {
  moment.locale("id");
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  const [data, setData] = useState(null);
  const [banner, setBanner] = useState(null);
  const [hideBanner, setHideBanner] = useState(Boolean);
  const [hideDefaultTitle, setHideDefaultTitle] = useState(Boolean);

  useEffect(() => {
    setHideBanner(checkIsFromDashboard(Router));
    setHideDefaultTitle(checkIsFromDashboard(Router));

    if (inIframe()) {
      setHideBanner(true);
      setHideDefaultTitle(true);
    }
  });

  const getRewards = async () => {
    const { status, data } = await fetch("GET", "/kentico/rewards");
    if (status == 200) {
      setData(data);
    }
  };

  const getBanners = async () => {
    const { status, data } = await fetch(
      "GET",
      `/kentico/slider`,
      {
        codename: rewardBanners
      },
      true
    );
    if (status == 200) {
      setBanner(data);
    }
  };

  useEffect(() => {
    getRewards();
    getBanners();
    setWinSize(width);
  }, []);

  return (
    <div className="reward-wrapper">
      <div className="reward-container">
        {rewardBanners && !hideBanner && (
          <Slider
            data={banner}
            infiniteScroll={true}
            autoScroll={true}
          ></Slider>
        )}
        <div className="reward-list-wrapper">
          {!hideDefaultTitle && (
            <HeadingComponent headingText="Home Credit Rewards" />
          )}
          {data && (
            <div className="reward-list">
              <div className="reward-card-wrapper">
                {data.map((r, idx) => {
                  return (
                    <CardContainer
                      key={idx}
                      img={r.banner}
                      button="Lihat"
                      buttonSize="Large"
                      title={r.title}
                      subtitle={`Periode ${moment(r.start_date).format(
                        "LL"
                      )} - ${moment(r.end_date).format("LL")}`}
                      href="/rewards/[slug]"
                      slug={`/rewards/${r.slug}`}
                      width={winSize}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      <style jsx>{`
        .reward-list-wrapper {
          margin-top: 30px;
          max-width: 940px;
          margin-left: auto;
          margin-right: auto;
        }
        .reward-list {
          display: flex;
          justify-content: center;
          margin: 40px 0;
          padding: 0 15px;
        }
        .reward-card-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-row-gap: 30px;
          grid-column-gap: 30px;
        }

        @media only screen and (max-width: 600px) {
          .reward-list-wrapper {
            margin-top: 0;
          }
          .reward-wrapper {
            padding-bottom: 30px;
          }
          .reward-card-wrapper {
            display: grid;
            grid-template-columns: 1fr;
            grid-row-gap: 30px;
          }
          .reward-list {
            margin: 5px 0;
          }
        }
      `}</style>
    </div>
  );
};

export default Reward;
